export default __webpack_public_path__ + "static/1501-1b3eb2cc19de2524f93b5be40f3939ed.gif";